export const DISCLAIMERS_URL = 'https://phepqaappstore01.blob.core.windows.net/disclosures'
